export default __webpack_public_path__ + "static/media/placeholder_blank-it-mobile.abfabdbd.png";